export let PENDING_CLOTHING: string;
export let PENDING_FORMATION: string;
export let PENDING_DOCUMENT: string;
export let PENDING_SURVEY: string;
export let COURSES: string;
export let CLOTHINGS: string;
export let SURVEYS: string;
export let DOCUMENTS: string;
export let ACCESS: string;
export let START: string;
export let SIGN: string;
export let SHOW_MORE: string;
export let SHOW_LESS: string;
export let INCORRECT_PASSWORD: string;
export let USER_NOT_ACTIVATED: string;
export let USER_NOT_EXIST: string;
export let LOGIN_ERROR: string;
export let GENERAL_ERROR: string;
export let GENERAL_ERROR_SUPPORT_MODE: string;
export let LOGIN_BLOCK_WARNING: string;
export let LOGIN_BLOCK_WARNING_SINGULAR: string;
export let LOGIN_BLOCK_ERROR: string;
export let LOGIN_BLOCK_ERROR_SINGULAR: string;
export let LOGIN_BLOCK_RESTORE_PASSWORD_URL: string;

$(() => {
  PENDING_CLOTHING = $("#sharedResources").attr("data-PENDING_CLOTHING")!;
  PENDING_FORMATION = $("#sharedResources").attr("data-PENDING_FORMATION")!;
  PENDING_DOCUMENT = $("#sharedResources").attr("data-PENDING_DOCUMENT")!;
  PENDING_SURVEY = $("#sharedResources").attr("data-PENDING_SURVEY")!;
  COURSES = $("#sharedResources").attr("data-COURSES")!;
  CLOTHINGS = $("#sharedResources").attr("data-CLOTHINGS")!;
  SURVEYS = $("#sharedResources").attr("data-SURVEYS")!;
  DOCUMENTS = $("#sharedResources").attr("data-DOCUMENTS")!;
  ACCESS = $("#sharedResources").attr("data-ACCESS")!;
  START = $("#sharedResources").attr("data-START")!;
  SIGN = $("#sharedResources").attr("data-SIGN")!;
  SHOW_MORE = $("#sharedResources").attr("data-SHOW_MORE")!;
  SHOW_LESS = $("#sharedResources").attr("data-SHOW_LESS")!;
  INCORRECT_PASSWORD = $("#sharedResources").attr("data-INCORRECT_PASSWORD")!;
  USER_NOT_ACTIVATED = $("#sharedResources").attr("data-USER_NOT_ACTIVATED")!;
  USER_NOT_EXIST = $("#sharedResources").attr("data-USER_NOT_EXIST")!;
  LOGIN_ERROR = $("#sharedResources").attr("data-LOGIN_ERROR")!;
  GENERAL_ERROR = $("#sharedResources").attr("data-GENERAL_ERROR")!;
  GENERAL_ERROR_SUPPORT_MODE = $("#sharedResources").attr(
    "data-GENERAL_ERROR_SUPPORT_MODE"
  )!;
  LOGIN_BLOCK_WARNING = $("#sharedResources").attr("data-LOGIN_BLOCK_WARNING")!;
  LOGIN_BLOCK_WARNING_SINGULAR = $("#sharedResources").attr(
    "data-LOGIN_BLOCK_WARNING_SINGULAR"
  )!;
  LOGIN_BLOCK_ERROR = $("#sharedResources").attr("data-LOGIN_BLOCK_ERROR")!;
  LOGIN_BLOCK_ERROR_SINGULAR = $("#sharedResources").attr(
    "data-LOGIN_BLOCK_ERROR_SINGULAR"
  )!;
  LOGIN_BLOCK_RESTORE_PASSWORD_URL = $("#sharedResources").attr(
    "data-LOGIN_BLOCK_RESTORE_PASSWORD_URL"
  )!;
});
